module.exports = __webpack_public_path__ + "static/media/ic_qr_code.dea27776.png";